// utils/routeByProductType.js
export const getAccessBasedRoute = (type) => {
  let path = "/admin/administration/user";
  let screen = "Administration";
  let subMenu = "Users";

  switch (type) {
    case "Administration":
      path = "/admin/administration/user";
      screen = "Administration";
      subMenu = "Users";
      break;
    case "HR Zone":
      path = "/admin/hrzone/employees";
      screen = "HR Zone";
      subMenu = "Employee";
      break;
    case "My Zone":
      path = "/admin/myzone/status";
      screen = "My Zone";
      subMenu = "Status";
      break;
    case "Payroll":
      path = "/admin/payroll/run/payroll";
      screen = "Payroll";
      subMenu = "Status";
      break;
    case "Project":
      path = "/admin/project/project-management";
      screen = "Project";
      subMenu = "Projects";
      break;
    case "Team Zone":
      path = "/admin/teamzone/attendance";
      screen = "Team Zone";
      subMenu = "Attendance";
      break;
    case "Support Admin":
      path = "/admin/support/admin";
      screen = "Support Admin";
      subMenu = "Product Control";
      break;
    case "Tracking":
      path = "/admin/tracking/triphistory";
      screen = "Tracking";
      subMenu = "Track";
      break;
    default:
      path = "/admin/administration/user";
      screen = "Administration";
      subMenu = "Users";
  }

  // Set common localStorage values
  localStorage.setItem("currentScreen", screen);
  localStorage.setItem("currentSubMenu", subMenu);
  return path;
};
